module.exports = __webpack_public_path__ + "img/dz.89763f24.gif";